module.exports = __webpack_public_path__ + "img/playersGroup_g.2e2eab5b.svg";